import type { State } from '../../types';
import type { RiskAssessmentViewModel } from '@trinnvis/dabih-api-client';

import { toList } from '../toList';

export function riskAssessmentsDeleted(state: State): RiskAssessmentViewModel[] {
  if (state.organization === undefined) return [];
  return toList(state.organization.riskAssessmentsById).filter((e) => e.deleted);
}
